@if (showAsHoliday()) {
  <div>
    Holiday
  </div>
}